import React from "react";
import TopupStatusTemplate from "../../../components/topup/TopupStatusTemplate/TopupStatusTemplate";
import ImageClockQuestionmark from "../../../images/clock-questionmark.svg";
import { useNavigate } from "react-router-dom";
import { ROUTES, usePlayGameMetaDescription } from "../../../utils/constants";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../../utils/renderHeaders";
import { useTranslation } from "react-i18next";

export default function TopupPending() {
  const navigate = useNavigate();
  const metaDescriptions = usePlayGameMetaDescription();
  const { t } = useTranslation();

  return (
    <>
      {renderHeaders({
        title: t("metadata:pending_top_up_hyper_gaming_app"),
        description: metaDescriptions.generic,
        ogTitle: extractOgTitleFromMainTitle(
          t("metadata:pending_top_up_hyper_gaming_app")
        ),
      })}

      <TopupStatusTemplate
        image={ImageClockQuestionmark}
        showSecondaryCta={false}
        mainCopy="Transaction Pending"
        subCopy="We'll notify you when your transaction is successful."
        primaryButtonText="Go to wallet"
        handlePrimaryAction={() => navigate(`${ROUTES.WALLET.ROOT}`)}
      />
    </>
  );
}
